<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col cols="12">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link
                            class="link-a"
                            :to="{
                                path: '/Inventory/Stock/' + pages,
                                query: { q: form_query },
                            }"
                            >STOCK</router-link
                        >
                        / ADD NEW PART & STOCK IN
                    </h1>
                </v-col>
            </v-row>
            <v-form method="post" id="nativeForm" v-model="valid">
                <v-card class="mt-5">
                    <v-card-title> </v-card-title>
                    <v-row class="mar-2">
                        <v-col cols="12" sm="6" md="4" class="pa-7">
                            <v-select
                                :items="dataGet.projects"
                                item-text="project_name"
                                item-value="project_id"
                                v-model="form.project_id"
                                menu-props="auto"
                                label="Project Name"
                                :rules="ProjectR"
                                required
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="pa-7">
                            <v-select
                                :items="dataGet.categories"
                                item-text="category_name"
                                item-value="category_id"
                                menu-props="auto"
                                label="Categories"
                                v-model="form.category_id"
                                :rules="CategoriesR"
                                required
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="pa-7">
                            <v-select
                                :items="dataGet.suppliers"
                                item-text="supplier_name"
                                item-value="supplier_id"
                                menu-props="auto"
                                label="Supplier"
                                v-model="form.supplier_id"
                                :rules="SupplierR"
                                required
                                hide-details
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row class="mar-2" v-if="form.project_id > 0">
                        <v-col cols="12" sm="6" class="pa-7">
                            <v-textarea
                                outlined
                                name="part_no"
                                label="Part No"
                                :rules="part_noR"
                                @keyup="checkpart()"
                                required
                                v-model="form.part_name"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="pa-7">
                            <v-textarea
                                outlined
                                name="part_desc"
                                label="Part Description"
                                v-model="form.part_description"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="4" class="pa-7 mar-1">
                            <v-select
                                :items="['MA', 'Install']"
                                menu-props="auto"
                                label="Part Type"
                                v-model="form.part_type"
                                :rules="SupplierR"
                                required
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="pa-7 mar-1">
                            <v-text-field
                                v-model="form.shipment"
                                label="Shipment"
                                :rules="ShipmentR"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="pa-7 mar-1">
                            <v-text-field
                                v-model="form.location"
                                label="Location"
                                :rules="LocationR"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-card-title>
                        <span class="headline headline-2"
                            >SET MINIMUM PART STOCK NONHP
                        </span>
                    </v-card-title>
                    <v-row
                        class="mar-2"
                        v-for="(n, index) in form.set_minimum"
                        :key="index"
                    >
                        <v-col cols="10" sm="5" md="4" class="pa-7">
                            <v-select
                                :items="data_branch"
                                item-text="branch_name"
                                item-value="branch_id"
                                v-model="n.branch"
                                menu-props="auto"
                                label="Select Branch"
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="10" sm="5" md="4" class="pa-7">
                            <v-text-field
                                v-model="n.total"
                                label="Total"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1" class="mt-5" v-if="index === num - 1">
                            <v-btn
                                color="success"
                                fab
                                small
                                class="mt-3"
                                @click="plus()"
                            >
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>

                <v-card class="mt-5">
                    <v-card-title>
                        <span class="headline headline-2">SERIAL PART </span>
                    </v-card-title>
                    <v-row class="">
                        <v-col col="12" sm="6">
                            <v-switch
                                v-model="form.is_na"
                                class="ma-1 pa-3"
                                label="NA"
                            ></v-switch>
                        </v-col>
                    </v-row>
                    <v-row class="mar-2">
                        <v-col col="12" sm="6">
                            <v-text-field
                                v-if="form.is_na === true"
                                label="QTY"
                                ref="na"
                                class="ma-1 pa-3"
                                v-model="form.qty"
                                :rules="QtyR"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mar-2">
                        <!-- :rules="serial_partR" -->
                        <v-col col="12" sm="6">
                            <v-textarea
                                v-if="form.is_na === false"
                                outlined
                                class="ma-1 pa-3"
                                ref="serial_part"
                                name="serial_part"
                                label="Serial Part"
                                v-model="form.serial"
                                required
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="mar-2">
                        <v-col cols="12" class="text-right">
                            <v-btn
                                color="success"
                                class="mr-5"
                                @click="save()"
                                :disabled="!valid"
                                rounded
                            >
                                <v-icon class="mr-1">mdi-content-save</v-icon>
                                Save</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-card>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import axios from "axios"
import VueRouter from "vue-router"
import { mapState, mapMutations } from "vuex"
import _ from "lodash"

const url = `${process.env.VUE_APP_ROOT_API}/api/stockin`

export default {
    computed: {
        ...mapState(["snackbar"]),
    },
    created() {
        this.checkpart = _.debounce(this.checkpart, 1000)
    },
    mounted() {
        this.get_data()
        this.get_branch()
        this.pages = this.$route.params.pages
        this.form_query = this.$route.query.q
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            let { data } = await axios.get(url)
            this.dataGet = data
        },
        async checkpart() {
            let part = {
                part_name: this.form.part_name,
            }

            if (this.chk_part === false && this.form.part_name != "") {
                this.chk_part = true
                await axios
                    .post(
                        `${process.env.VUE_APP_ROOT_API}/api/check-part-name/` +
                            this.form.project_id,
                        part
                    )
                    .then((response) => {
                        if (response.data.status === "error") {
                            this.form.part_name = ""
                            this.$swal(response.data.message, {
                                icon: "warning",
                                button: false,
                                timer: 1500,
                            })
                        } else {
                            this.$swal(response.data.message, {
                                icon: "success",
                                button: false,
                                timer: 1500,
                            })
                        }
                        this.chk_part = false
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        async save() {
            await axios
                .post(url, this.form, {
                    headers: { Authorization: "Bearer " + localStorage.token },
                })
                .then((response) => {
                    this.chk_save = false
                    this.mutatesnackbar()
                    // this.$root.$router.push({
                    //     path: "/Inventory/Stock/" + this.pages,
                    // })
                    let urlx =
                        "/Inventory/Stock-In/Barcode/" +
                        1 +
                        "/" +
                        response.data.part_id
                    this.$router.push({
                        path: urlx,
                    })
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_branch() {
            let { data } = await axios.get(
                `${process.env.VUE_APP_ROOT_API}/api/getbranch`
            )
            this.data_branch = data
        },
        plus() {
            this.num = this.num + 1
            this.form.set_minimum.push({
                branch: "",
                total: "",
            })
        },
    },
    data() {
        return {
            dataGet: [],
            form: {
                project_id: 0,
                part_id: null,
                is_na: false,
                set_minimum: [
                    {
                        branch: "",
                        total: "",
                    },
                ],
            },
            chk_part: false,
            pages: 0,
            valid: false,
            ProjectR: [(v) => !!v || "Project Name is required"],
            CategoriesR: [(v) => !!v || "Categories is required"],
            SupplierR: [(v) => !!v || "Supplier is required"],
            ShipmentR: [(v) => !!v || "Shipment is required"],
            LocationR: [(v) => !!v || "Location is required"],
            part_noR: [(v) => !!v || "Part No is required"],

            QtyR: [
                (v) => !!v || "QTY is required",
                (v) => /^\d+$/.test(v) || "Must be a number",
            ],
            totalR: [(v) => /^\d+$/.test(v) || "Must be a number"],
            data_branch: [],
            num: 1,
            form_query: null,
        }
    },
}
</script>

<style scoped>
.mar-1 {
    margin-top: -30px;
    margin-left: 0px !important;
}
.mar-2 {
    margin-top: -30px !important;
}
@media screen and (max-width: 960px) and (min-width: 600px) {
    .mar-1 {
        margin-top: 0px !important;
        margin-left: 0px !important;
    }
}
</style>
